var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRank6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14.3772,
    r: 13.5293,
    fill: "url(#paint0_linear_4229_8309)",
    stroke: "url(#paint1_linear_4229_8309)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1399 21.0363C14.5036 21.0363 13.8937 20.934 13.3104 20.7295C12.727 20.5211 12.2081 20.1916 11.7536 19.7408C11.299 19.2863 10.9411 18.6916 10.6797 17.9567C10.4183 17.2181 10.2895 16.3185 10.2933 15.2579C10.2971 14.2995 10.4145 13.4397 10.6456 12.6783C10.8767 11.9132 11.2062 11.2636 11.6342 10.7295C12.0661 10.1954 12.5812 9.78818 13.1797 9.50788C13.782 9.22379 14.4543 9.08174 15.1967 9.08174C16.0111 9.08174 16.7289 9.24083 17.3501 9.55902C17.9751 9.87341 18.4751 10.2977 18.8501 10.8317C19.2251 11.362 19.4467 11.953 19.5149 12.6045H16.7479C16.6645 12.237 16.4808 11.9586 16.1967 11.7692C15.9164 11.5761 15.5831 11.4795 15.1967 11.4795C14.4846 11.4795 13.9524 11.7882 13.6001 12.4056C13.2517 13.023 13.0736 13.8488 13.0661 14.8829H13.1399C13.299 14.5344 13.5282 14.2352 13.8274 13.9852C14.1267 13.7352 14.4695 13.5439 14.8558 13.4113C15.246 13.2749 15.6589 13.2067 16.0945 13.2067C16.7914 13.2067 17.407 13.3677 17.9411 13.6897C18.4751 14.0117 18.8937 14.453 19.1967 15.0136C19.4998 15.5704 19.6494 16.2086 19.6456 16.9283C19.6494 17.7389 19.46 18.4548 19.0774 19.0761C18.6948 19.6935 18.1645 20.1745 17.4865 20.5192C16.8123 20.8639 16.0301 21.0363 15.1399 21.0363ZM15.1229 18.8772C15.4676 18.8772 15.7763 18.7958 16.049 18.6329C16.3217 18.47 16.5357 18.2484 16.6911 17.9681C16.8464 17.6878 16.9221 17.3715 16.9183 17.0192C16.9221 16.6632 16.8464 16.3469 16.6911 16.0704C16.5395 15.7939 16.3274 15.5742 16.0547 15.4113C15.7857 15.2484 15.477 15.167 15.1286 15.167C14.8748 15.167 14.638 15.2143 14.4183 15.309C14.1986 15.4037 14.0073 15.5363 13.8445 15.7067C13.6854 15.8734 13.5604 16.0704 13.4695 16.2977C13.3786 16.5211 13.3312 16.7636 13.3274 17.0249C13.3312 17.3696 13.4107 17.6821 13.5661 17.9624C13.7214 18.2427 13.9335 18.4662 14.2024 18.6329C14.4714 18.7958 14.7782 18.8772 15.1229 18.8772Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4229_8309",
    x1: 15,
    y1: 0.3479,
    x2: 15,
    y2: 28.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AED8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3E52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4229_8309",
    x1: 15,
    y1: 0.3479,
    x2: 15,
    y2: 28.4065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11273D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank6);
export default __webpack_public_path__ + "static/media/rank6.9fefc21434c8e15688f43d6751d2e74f.svg";
export { ForwardRef as ReactComponent };